import React, { useState } from 'react'
import Intro from './Intro';
import DynamicModal from "../DynamicModal/DynamicModal"
import VerifyViaPhoneNo from './VerifyViaPhoneNo';
import VerifyViaOTP from './VerifyViaOTP';
import AnsBelowQues from './AnsBelowQues';
import DetailsNotFound from './DetailsNotFound';
import Header from '../Header';
import Sidebar from '../Sidebar';
import CandidateTab from '../CandidateTab';
import Loader from '../Common/loader';
import NotificationPanels from '../NotificationPanels';
import ClientHeader from "../Partials/ClientHeader";
import ClientSideBar from "../Partials/ClientSideBar";
import ProgressHeading from '../Common/ProgressHeading';

const MainFormCreditHistory = () => {
    // const [showIntro, setShowIntro] = useState(false);
    const [showModal3, setShowModal3] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [role, setRole] = useState();


    const handleConfirm = () => {
        // Logic for handling confirmation
        console.log('Confirmed');
        // Proceed with further action
    };

    const modalContent3 = {
        head: "Phone validation failed",
        body: "content",
        content:
            "Try using other phone number(s) linked with you bank/credit card.",
        footer: "Continue",
        showCancel: false, // Render "Cancel" button
        icon: '../../assets/img/exclamation-mark-icon.svg', // Icon/image URL for modal 3
    };

    return (
        <>
            {isLoading && <Loader />}
            <NotificationPanels />
            {role == "EP" ? <ClientHeader /> : <Header />}
            {role == "EP" ? <ClientSideBar /> : <Sidebar />}
            <section className="main-section candidate-tab-form" style={{ paddingTop: "60px" }}>
                <div className="container-fluid">
                    <div className="row bg-gray-mbl m-0 p-1">
                        <div className="col-auto w-100-mbl bg-gray-mbl">
                            <ProgressHeading/>
                            <CandidateTab activeTab={"Credit History"} />
                        </div>
                        <div className="col-lg-9 col-md-12 col-sm-12 p-0 m-0 col bg-gray-mbl">
                            <h2 className="fnt-smi-bld">Credit History</h2>
                            <p className="text-muted">
                                To obtain Credit Information Report from a credit bureau, ensure that the entered mobile number & email address are associated with your bank & credit cards.
                            </p>
                            <hr />

                            {/* {showIntro( */}
                            {/* <Intro /> */}
                            {/* )} */}

                            <DynamicModal
                                show={showModal3}
                                onHide={() => setShowModal3(false)}
                                modalContent={modalContent3}
                                onConfirm={handleConfirm}
                            />

                            <VerifyViaPhoneNo />

                            <VerifyViaOTP />

                            <AnsBelowQues />

                            <DetailsNotFound />

                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default MainFormCreditHistory